/* eslint-disable no-prototype-builtins */
import React, { useState, useEffect } from 'react'
import { useNavigate, useParams, Link } from 'react-router-dom'
import axios from 'axios'
import ReactHtmlParser from 'react-html-parser'

import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import Divider from '@mui/material/Divider'
import FormatQuoteIcon from '@mui/icons-material/FormatQuote'
import InterestsIcon from '@mui/icons-material/Interests'

import { viewFeedbackAndVerdictForItemJSX } from '../../../analysisJSX/viewFeedbackAndVerdictForItemJSX'
import { positionChangeWidthSm, tinderProfileBackgroundColor, tinderProfileItemBackgroundColor, tinderProfileItemBorderColor, tinderProfileTextColor, tinderProfilePromptTextColor, tinderProfileItemDividerOpacity, tinderProfileItemBoxShadow, tinderProfileItemBorderWidth, tinderProfileItemBorderRadius, tinderProfileImageWidth, tinderProfileImageIndicatorWidth, tinderLeadImageHeight, tinderImageHeight } from '../../../../../helpers/variableDefaults'

export const viewTinderAboutMeItem = (viewFeedbackTrue, giveFeedbackTrue, datingProfile, width) => {
  // console.log('datingProfile ->', datingProfile)

  const showHobbies = () => {
    return 'hobbies' in datingProfile.bio && datingProfile.bio.hobbies.length > 0 && datingProfile.bio.hobbies.filter(hobby => hobby.length > 0).length > 0
  }

  return (
    <Box
      sx={{
        mt: 2, 
        // px: 2, py: 2,
        width: tinderProfileImageWidth(width),
        backgroundColor: tinderProfileItemBackgroundColor,
        boxShadow: tinderProfileItemBoxShadow, 
        borderRadius: tinderProfileItemBorderRadius,
      }}
    >
      {/* Title */}
      <Box
        sx={{
          // mt: (viewFeedbackTrue || giveFeedbackTrue) ? 2 : .5,
          mt: .5,
          px: 2, py: 1,
          color: tinderProfilePromptTextColor,
          display: 'flex', flexDirection: 'row', justifyContent: 'flex-start', alignItems: 'center',
        }}
      >
        < FormatQuoteIcon
          sx={{
            // width: '30px', height: '30px',
            mr: 1,
            // '-webkit-transform': 'rotate(-180deg)',
            transform: 'rotate(-180deg)',
          }}
        />
        <Typography
          sx={{
            fontSize: '14px',
            fontWeight: 'bold',
          }}
        >
          About me
        </Typography>
      </Box>

      {/* About Me */}
      <Box
        sx={{
          pt: 0, pb: showHobbies() ? 1 : 2, px: 2,
          color: tinderProfileTextColor,
          display: 'flex', flexDirection: 'column', justifyContent: 'flex-start', alignItems: 'flex-start',
        }}
      >
        {datingProfile.bio.aboutMe}
      </Box>
      
      {
        // (viewFeedbackTrue || giveFeedbackTrue) && 
        showHobbies() 
        &&
        <>
          <Box
            sx={{
              // mt: (viewFeedbackTrue || giveFeedbackTrue) ? 2 : .5,
              mt: .5,
              px: 2, py: 1,
              color: tinderProfilePromptTextColor,
              display: 'flex', flexDirection: 'row', justifyContent: 'flex-start', alignItems: 'center',
            }}
          >
            < InterestsIcon
              sx={{
                width: '20px', height: '20px',
                mr: 1.2,
                // '-webkit-transform': 'rotate(-180deg)',
                // transform: 'rotate(-180deg)',
              }}
            />
            <Typography
              sx={{
                fontWeight: 'bold',
                fontSize: '14px',
              }}
            >
              Interests
            </Typography>
          </Box>
          <Box
            sx={{
              pt: 0, pb: 0, px: 2, mb: 2,
              display: 'flex', flexDirection: 'row', justifyContent: 'flex-start', alignItems: 'flex-start',
              flexWrap: 'wrap',
            }}
          >
            {datingProfile.bio.hobbies.filter(hobbyItemToFilter => hobbyItemToFilter.length > 0).map((hobbyItem, hobbyItemIndex) => (
              <Box
                key={hobbyItemIndex}
                sx={{
                  mr: 1, my: 0.5,
                  px: 1, py: .75,
                  // border: 2,
                  backgroundColor: '#505050',
                  borderRadius: 5,
                  borderColor: 'black',
                  color: tinderProfileTextColor,
                  fontSize: '14px',
                }}
              >
                {hobbyItem}
              </Box>
            ))}
          </Box>
        </>
      }

      {viewFeedbackTrue && datingProfile.bioFeedback.aboutMeFeedback.feedback.length > 0 && datingProfile.bioFeedback.aboutMeFeedback.verdict.length > 0 &&
        <Box
          sx={{
            width: tinderProfileImageWidth(width),
            borderRadius: `0px 0px ${tinderProfileItemBorderRadius} ${tinderProfileItemBorderRadius}`,
            display: 'flex', flexDirection: 'column', justifyContent: 'flex-start', alignItems: 'flex-start',
          }}
        >
          {/* Divider */}
          <Divider sx={{ width: '100%', my: 0 }} orientation="horizontal" />

          {/* Feedback and Verdict */}
          {viewFeedbackAndVerdictForItemJSX(datingProfile.bioFeedback.aboutMeFeedback, 'aboutMe', datingProfile.type)}

        </Box>
      }

    </Box>
  )
}